var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _path12, _path13, _polygon2, _path14, _polygon3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon4, _path22, _path23, _path24, _path25, _path26, _path27, _polygon5, _polygon6, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.68 22.68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1, .cls-2 {\n        fill: currentColor;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M7.08,11.81c-.46-.57-.8-1.26-.96-2.03-.3-1.34-.04-2.69.62-3.77.28-.46.64-.88,1.05-1.23l.5.62c-.35.29-.65.64-.89,1.03-.55.9-.77,2.04-.52,3.16.15.65.43,1.23.81,1.72l-.61.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M15,4.9c.55.48,1,1.1,1.3,1.83.52,1.26.5,2.64.02,3.83-.2.51-.47.98-.83,1.4l-.6-.52c.3-.35.53-.75.7-1.17.4-1,.42-2.15-.02-3.22-.26-.61-.63-1.13-1.1-1.54l.52-.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M5.7,12.95c-.62-.78-1.08-1.72-1.31-2.77-.41-1.83-.06-3.66.85-5.14.38-.63.88-1.19,1.44-1.67l.49.62c-.5.41-.93.92-1.27,1.48-.8,1.3-1.11,2.92-.74,4.54.2.92.62,1.75,1.16,2.44l-.61.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M16.16,3.53c.74.66,1.36,1.5,1.77,2.49.71,1.73.68,3.6.04,5.22h0c-.27.69-.66,1.34-1.13,1.91l-.59-.53c.42-.5.76-1.06,1.01-1.67.56-1.43.59-3.08-.04-4.61-.37-.87-.91-1.62-1.57-2.2l.51-.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M4.32,14.09c-.79-.99-1.37-2.18-1.67-3.51-.52-2.32-.06-4.64,1.08-6.51h0c.49-.8,1.1-1.52,1.83-2.12l.49.62c-.66.54-1.22,1.19-1.66,1.92-1.04,1.7-1.44,3.8-.98,5.91.28,1.21.8,2.28,1.52,3.19l-.61.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M17.33,2.15c.94.83,1.72,1.9,2.24,3.16.9,2.19.86,4.56.05,6.61-.35.87-.82,1.69-1.44,2.41l-.59-.52c.55-.66.99-1.4,1.3-2.19.73-1.86.78-4-.04-6-.47-1.14-1.17-2.1-2.03-2.87l.52-.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M2.42,15.68c-1.01-1.29-1.76-2.82-2.15-4.54-.67-3-.09-6,1.4-8.41.63-1.03,1.43-1.95,2.35-2.73l.5.62c-.86.72-1.6,1.58-2.19,2.54-1.37,2.24-1.91,5.02-1.29,7.8.35,1.6,1.05,3.02,1.99,4.21l-.61.51Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M18.92.26c1.22,1.08,2.22,2.45,2.89,4.07,1.17,2.83,1.11,5.88.07,8.53h0c-.44,1.13-1.06,2.19-1.84,3.12l-.6-.53c.73-.87,1.31-1.85,1.73-2.89.97-2.45,1.02-5.28-.07-7.91-.62-1.51-1.55-2.78-2.68-3.78l.51-.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M12.57,8.75c0,.62-.49,1.11-1.09,1.11s-1.09-.5-1.09-1.11.49-1.11,1.09-1.11,1.09.5,1.09,1.11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M7.89,22.1h.46l-.14-.39c-.05-.12-.08-.21-.1-.29-.02.09-.04.18-.07.27l-.15.41ZM7.49,22.68l.52-1.4h.2l.56,1.4h-.21l-.16-.42h-.57l-.15.42h-.19Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    fill: "#ce0e2d",
    points: "8.9 22.68 8.9 21.28 9.09 21.28 9.09 22.51 9.76 22.51 9.76 22.68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M10.22,22.1h.46l-.14-.39c-.04-.12-.07-.21-.1-.29-.02.09-.04.18-.07.27l-.15.41ZM9.82,22.68l.52-1.4h.19l.56,1.4h-.21l-.16-.42h-.57l-.15.42h-.19Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M11.43,21.9h.39c.08,0,.15,0,.19-.03l.11-.08.04-.13-.07-.16s-.12-.06-.22-.06h-.43v.46ZM11.25,22.68v-1.4h.6c.12,0,.22.01.28.04l.15.13c.04.06.06.13.06.21,0,.1-.03.18-.09.25-.06.07-.16.11-.29.13l.11.07c.05.05.1.11.15.18l.24.38h-.23l-.18-.29c-.05-.08-.1-.15-.13-.19l-.09-.09-.08-.04h-.1s-.21,0-.21,0v.62h-.18Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M12.61,22.68v-1.4h.27l.32.99c.03.09.05.16.07.21.02-.05.04-.13.07-.22l.32-.97h.25v1.4h-.18v-1.17l-.39,1.17h-.16l-.4-1.19v1.19h-.17Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    fill: "#ce0e2d",
    points: "14.21 22.68 14.21 21.28 15.19 21.28 15.19 21.44 14.39 21.44 14.39 21.87 15.14 21.87 15.14 22.04 14.39 22.04 14.39 22.51 15.23 22.51 15.23 22.68"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M6.46,19.3h.46l-.14-.39c-.04-.12-.07-.22-.1-.29-.02.09-.04.18-.07.27l-.15.41ZM6.06,19.88l.52-1.4h.19l.56,1.4h-.21l-.16-.42h-.57l-.15.42h-.19Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    fill: "#ce0e2d",
    points: "7.48 19.88 7.48 18.48 7.66 18.48 7.66 19.71 8.33 19.71 8.33 19.88"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M8.79,19.3h.46l-.14-.39c-.04-.12-.08-.22-.1-.29-.02.09-.04.18-.07.27l-.15.41ZM8.39,19.88l.52-1.4h.19l.56,1.4h-.21l-.16-.42h-.57l-.15.42h-.19Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M10,19.09h.39c.08,0,.15,0,.19-.02l.11-.08.03-.13-.07-.16s-.12-.06-.22-.06h-.43v.46ZM9.82,19.88v-1.4h.6c.12,0,.21.01.28.04l.15.13c.04.06.06.13.06.21,0,.1-.03.18-.09.25-.06.07-.16.11-.29.13l.11.07c.05.05.1.11.15.19l.24.38h-.23l-.18-.29c-.05-.09-.1-.15-.13-.19l-.09-.09-.08-.04h-.1s-.21,0-.21,0v.62h-.18Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M11.18,19.88v-1.4h.27l.32.99c.03.09.05.16.07.21.02-.05.04-.13.07-.22l.33-.97h.24v1.4h-.17v-1.17l-.4,1.17h-.16l-.39-1.19v1.19h-.17Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M13.02,19.3h.46l-.14-.39c-.04-.12-.08-.22-.1-.29-.02.09-.04.18-.07.27l-.15.41ZM12.63,19.88l.52-1.4h.2l.56,1.4h-.21l-.16-.42h-.57l-.15.42h-.19Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M14.23,19.71h.29c.09,0,.16,0,.21-.02l.12-.07s.08-.1.1-.18c.03-.07.04-.16.04-.27,0-.15-.03-.26-.07-.34-.05-.08-.1-.13-.17-.16-.05-.02-.13-.03-.23-.03h-.29v1.07ZM14.05,19.88v-1.4h.47c.11,0,.19,0,.24.02.08.02.14.05.2.1.07.06.12.14.16.24.04.1.06.21.06.33,0,.11-.01.2-.04.28-.02.08-.06.15-.09.2l-.13.13-.16.07c-.06.02-.14.02-.22.02h-.49Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M15.55,19.2c0,.17.04.3.13.4.09.1.2.15.33.15s.25-.05.34-.15c.09-.1.13-.24.13-.42,0-.11-.02-.21-.06-.3-.04-.09-.09-.15-.16-.2-.07-.05-.15-.07-.24-.07-.13,0-.24.05-.33.14-.09.09-.14.24-.14.45M15.37,19.2c0-.23.06-.41.18-.54.12-.13.28-.2.47-.2.13,0,.24.03.34.09.1.06.18.15.23.26.05.11.08.23.08.37s-.03.27-.08.38c-.06.11-.14.2-.24.25-.1.06-.21.09-.33.09-.13,0-.24-.03-.34-.09-.1-.06-.18-.15-.23-.26-.05-.11-.08-.23-.08-.35"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M4.36,16.5h.46l-.14-.39c-.04-.12-.08-.21-.1-.29-.02.09-.04.18-.07.27l-.15.41ZM3.97,17.08l.52-1.4h.19l.56,1.4h-.21l-.16-.42h-.57l-.15.42h-.19Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    fill: "#ce0e2d",
    points: "5.37 17.08 5.37 15.68 5.55 15.68 5.55 16.91 6.23 16.91 6.23 17.08"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M6.68,16.5h.46l-.14-.39c-.04-.12-.08-.21-.1-.29-.02.09-.04.18-.07.27l-.15.41ZM6.28,17.08l.52-1.4h.2l.56,1.4h-.21l-.16-.42h-.57l-.15.42h-.19Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M7.88,16.3h.39c.08,0,.15,0,.19-.03l.1-.08.04-.13-.07-.16s-.12-.06-.22-.06h-.43v.46ZM7.7,17.08v-1.4h.6c.12,0,.21.01.28.04l.15.13c.04.06.06.13.06.21,0,.1-.03.18-.09.25-.06.07-.16.11-.29.13l.11.07c.05.05.1.11.15.19l.24.38h-.23l-.18-.29c-.05-.09-.1-.15-.13-.19l-.09-.09-.08-.03h-.1s-.21,0-.21,0v.62h-.18Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M9.05,17.08v-1.4h.27l.32.99c.03.09.05.16.06.21.02-.05.04-.13.07-.22l.33-.97h.24v1.4h-.17v-1.17l-.4,1.17h-.16l-.39-1.19v1.19h-.18Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M11.11,16.63h.17s.06.16.06.16l.14.11c.06.03.13.04.21.04l.18-.03.12-.08.04-.12-.04-.11-.12-.08s-.12-.04-.24-.07c-.12-.03-.21-.06-.26-.09l-.15-.13-.05-.17.06-.2c.04-.06.1-.11.17-.14.08-.03.16-.05.25-.05.1,0,.19.02.26.05.08.03.14.08.18.15.04.06.06.14.07.22h-.17c0-.08-.04-.14-.1-.19-.05-.05-.13-.07-.24-.07s-.19.02-.24.06l-.08.15.05.12s.12.06.27.1c.15.04.25.06.3.09.08.04.14.09.18.14.04.06.06.12.06.2s-.02.15-.06.21c-.04.07-.1.12-.18.15-.08.04-.16.05-.26.05-.12,0-.23-.02-.31-.05-.08-.04-.15-.09-.2-.17-.05-.07-.07-.16-.07-.25"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ce0e2d",
    d: "M12.82,17.08v-.59l-.52-.81h.22l.27.42c.05.08.1.16.14.24.04-.07.09-.15.15-.25l.26-.41h.21l-.54.81v.59h-.18Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M13.65,16.63h.17s.06.16.06.16l.14.11c.06.03.13.04.21.04l.18-.03.12-.08.04-.12-.04-.11-.12-.08s-.12-.04-.24-.07c-.12-.03-.21-.06-.26-.09l-.15-.13-.05-.17.06-.2c.04-.06.1-.11.17-.14.07-.03.16-.05.25-.05.1,0,.19.02.27.05.08.03.14.08.18.15.04.06.06.14.07.22h-.17c0-.08-.04-.14-.09-.19-.05-.05-.13-.07-.24-.07-.11,0-.19.02-.24.06l-.07.15.05.12s.12.06.27.1c.15.04.25.06.3.09.08.04.14.09.18.14.04.06.06.12.06.2s-.02.15-.06.21c-.04.07-.1.12-.18.15-.08.04-.16.05-.26.05-.12,0-.23-.02-.31-.05-.08-.04-.15-.09-.2-.17-.05-.07-.07-.16-.07-.25"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    fill: "#ce0e2d",
    points: "15.32 17.08 15.32 15.84 14.88 15.84 14.88 15.68 15.96 15.68 15.96 15.84 15.51 15.84 15.51 17.08"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    fill: "#ce0e2d",
    points: "16.14 17.08 16.14 15.68 17.13 15.68 17.13 15.84 16.33 15.84 16.33 16.27 17.08 16.27 17.08 16.43 16.33 16.43 16.33 16.91 17.16 16.91 17.16 17.08"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ce0e2d",
    d: "M17.41,17.08v-1.4h.27l.32.99c.03.09.05.16.06.21.02-.05.04-.13.07-.22l.33-.97h.24v1.4h-.17v-1.17l-.4,1.17h-.16l-.4-1.19v1.19h-.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmhome);
export default __webpack_public_path__ + "static/media/ALARMHOME.1cbc41de4ea5884b007ce3075d0733b3.svg";
export { ForwardRef as ReactComponent };